import { render, staticRenderFns } from "./dg-status-tip.vue?vue&type=template&id=f6b5e796&scoped=true"
import script from "./dg-status-tip.vue?vue&type=script&lang=js"
export * from "./dg-status-tip.vue?vue&type=script&lang=js"
import style0 from "./dg-status-tip.vue?vue&type=style&index=0&id=f6b5e796&prod&lang=less&scoped=true"
import style1 from "./dg-status-tip.vue?vue&type=style&index=1&id=f6b5e796&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b5e796",
  null
  
)

export default component.exports